import React from "react";
import type {FunctionComponent} from "react";
import s from "./CardSlider.module.scss";
import {FontIcon} from "../common/FontIcon";
import {MusicGroupPage} from "../../pages/songs/MusicGroupPage";

export interface ICardSliderProps {
  hasHeader: boolean;
  headerTitle?: string;
  isSelected: boolean;
  seeAll: () => void;
  backToMusicHome: () => void;
}

export const CardSlider: FunctionComponent<ICardSliderProps> = ({hasHeader, headerTitle, children, isSelected, seeAll, backToMusicHome}) => {
  return <section className={s.cardSlider}>
    {hasHeader ?
      <header className={s.cardSliderHeader}>
        <h3 className={s.cardSliderTitle}>{headerTitle}</h3>
        <button type={'button'} className={s.seeAll}>
          <span className={s.seeAllLabel} aria-label={`See all items in ${headerTitle}`} onClick={() => seeAll()}>
            See all
          </span>
          <FontIcon icon={"icon-angle-right"} />
        </button>
      </header>
      : null
    }
    <div className={s.cardSliderContent}>
      {children}
    </div>
    {isSelected ?
      <div style={{position: "absolute", top: 0, bottom: 0, left: 0, right: 0, backgroundColor: "white", zIndex: 4}}>
        <MusicGroupPage title={headerTitle ?? ''} onBack={backToMusicHome}>
          {children}
        </MusicGroupPage>
      </div> : null}
  </section>;
}

